export const formatDateforAPI = (date) => {
  if (!date) return null;

  const d = new Date(date);

  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0"); //Js month starts at 0
  const dd = String(d.getDate()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd}`;
};

export const formatDateTime = (
  date,
  options = { date: true, time: true }
) => {
  if (!date) {
    return { date: "-", time: "-" };
  }

  const d = new Date(date);
  if (isNaN(d)) {
    return { date: "-", time: "-" };
  }

  const result = {};

  if (options.date) {
    result.date = d.toLocaleDateString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
  }

  if (options.time) {
    result.time = d.toLocaleTimeString("en-IN", {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    });
  }

  return result;
};

export const formatDateOnly = (date) => {
  if (!date) return "-";

  const d = new Date(date);
  if (isNaN(d)) return "-";

  return d.toLocaleDateString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  });
};

export const formatTZS = (value) => {
  if (value === null || value === undefined || value === "") {
    return "TZS 0.00";
  }

  return `TZS ${Number(value).toLocaleString("en-TZ", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};



export const formatNumber = (amount) => {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};



